import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-data-science',
    templateUrl: './data-science.component.html',
    styleUrls: ['./data-science.component.css'],
    standalone: false
})
export class DataScienceComponent implements OnInit {
  showForm: boolean = false;

  openCta(): void {
  window.open('https://zfrmz.in/th79mqpJrPEauzdclebY');
}


  closeCta() {
    this.showForm = false; // closes form
  }


  faqs = [
    {
      question: 'What are the prerequisites?',
      answer: 'No prior experience is required. Basic computer literacy is helpful, but we cover all fundamentals from scratch.',
      open: false
    },
    {
      question: 'What is the class schedule like?',
      answer: 'Classes are held weekday evenings and weekends to accommodate working professionals and students.',
      open: false
    },
    {
      question: 'How are projects evaluated?',
      answer: 'Projects are evaluated by mentors based on creativity, functionality, code quality, and presentation.',
      open: false
    },
    {
      question: 'What kind of jobs can I expect after this program?',
      answer: 'You can expect roles like Frontend Developer, Backend Developer, Full Stack Developer, or Software Engineer depending on your specialization and portfolio.',
      open: false
    }
  ];

  constructor() { }

  ngOnInit(): void {}

  toggleFAQ(index: number): void {
    this.faqs[index].open = !this.faqs[index].open;
  }

}
